import Visualizations from '../components/course/visualizations';
<template><Visualizations @model={{@model}} /></template>
